import React, { useEffect, useRef } from "react";
import AllProducts from "../../components/AllProducts/AllProducts";
import Navbar from "../../components/Home/navbar/Navbar";

const AllProductsPage = () => {
  const scrollToTop = useRef(null);

  useEffect(() => {
    scrollToTop.current.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div ref={scrollToTop}>
      <div className="sticky top-0 z-50">
        <Navbar />
      </div>
      <AllProducts />
    </div>
  );
};

export default AllProductsPage;
